module.exports = __webpack_public_path__ + "img/xy.6c685655.jpeg";